(function () {
	const initProductAccordion = () => {
		$(".product-about__accordion-title")
			.off("click.productAccordion")
			.on("click.productAccordion", function () {
			const $title = $(this);
			const $container = $title.closest(".product__info-container");
			const $content = $title.siblings(".product-about__accordion-content");
			const initialTop = this.getBoundingClientRect().top;

			if (!$title.hasClass("active")) {
				const $activeTitles = $container
					.find(".product-about__accordion-title.active")
					.not($title);
				const $activeContents = $activeTitles.siblings(
					".product-about__accordion-content"
				);

				$activeTitles.removeClass("active");
				$activeContents.stop(true, true).hide();

				$title.addClass("active");
				$content.stop(true, true).show();
			} else {
				$title.removeClass("active");
				$content.stop(true, true).hide();
			}

			requestAnimationFrame(() => {
				const updatedTop = this.getBoundingClientRect().top;
				const topDelta = updatedTop - initialTop;

				if (Math.abs(topDelta) > 1) {
					window.scrollBy(0, topDelta);
				}
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
